import React, { useState, useEffect, useCallback } from 'react';
import debounce from 'lodash.debounce';
import * as mainService from '@app/services/mainService';
import SanphamLayoutComponent from '@app/pages/FUtil/SanphamLayoutComponent';
const SanphamAutocompleteComponent = ({ path_access, currentSuggestion ,onChange}) => {
  const [query, setQuery] = useState('');
  const [suggestions, setSuggestions] = useState([]);

  // Function to fetch suggestions
  const fetchSuggestions = async (newQuery) => {
    if (newQuery.length > 0) {
      try {
        // const response = await axios.get(`/api/search?query=${query}`);
        const response = await mainService.getAutocompletesanpham({
          path_access: path_access,
          search_text: newQuery,
        });
        setSuggestions(response);
      } catch (error) {
        console.error('Error fetching suggestions:', error);
      }
    } else {
      setSuggestions([]);
    }
  };

  // Create a debounced version of the fetchSuggestions function
  const debouncedFetchSuggestions = useCallback(debounce(fetchSuggestions, 300), []);

  // useEffect to call the debounced function on query change
  useEffect(() => {
    debouncedFetchSuggestions(query);
  }, [query, debouncedFetchSuggestions]);

  const handleInputChange = (event) => {
    setQuery(event.target.value);
  };

  if(currentSuggestion)
  {
    return (
        <SanphamLayoutComponent
          showClose={1}
          onChange={onChange}
          currentSuggestion = {currentSuggestion}
        />

        )
  }

  return (
    <div className="autocomplete">
      <input
        type="text"
        className="form-control"
        value={query}
        onChange={handleInputChange}
        placeholder="Tìm kiếm..."
      />
      {suggestions.length > 0 && (
        <ul className="list-group">
          {suggestions.map((suggestion, index) => (
            <div className="Button">
            <li key={index} className="list-group-item" onClick={() => { setQuery(''); onChange({value:suggestion}) ; } }>
             {/* <img src={suggestion.image} alt={suggestion.ten } className="img-thumbnail" width="70" />*/}
              {suggestion.ten+ ' - ' + suggestion.ma}
            </li>
            </div>
          ))}
        </ul>
      )}
    </div>
  );
};

export default SanphamAutocompleteComponent;





